import useDefinedContext from "hooks/useDefinedContext";
import DrawingActionsContext from "../contexts/DrawingActionsContext";

interface UseDrawingActionsProps {}

function useDrawingActions(props?: UseDrawingActionsProps) {
  return useDefinedContext(DrawingActionsContext);
}

export default useDrawingActions;
